import { useState, type ReactNode } from "react";

import Sidebar from "@/components/Sidebar";
import { VerificationProvider } from "@/components/VerificationManager/VerificationContext";
import { cn } from "@/lib/utils";

interface AppLayoutProps {
  children: ReactNode;
}

// Wraps every protected route in the same chrome (collapsible sidebar +
// page padding) and provides the cross-cipher VerificationContext so any
// nested screen can read/write the pending count without re-rendering the
// shell. The collapse state is local: persistence to a cookie/localStorage
// is a Phase 06 polish item.
export default function AppLayout({ children }: AppLayoutProps) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <VerificationProvider>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
        <Sidebar
          isCollapsed={isCollapsed}
          onToggleCollapse={() => setIsCollapsed((v) => !v)}
        />
        <main
          className={cn(
            "transition-all duration-300 ease-in-out",
            isCollapsed ? "md:ml-20" : "md:ml-72",
          )}
        >
          <div className="p-4 md:p-8 max-w-7xl mx-auto">{children}</div>
        </main>
      </div>
    </VerificationProvider>
  );
}
